"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNavigationDefinitions = void 0;
function getNavigationDefinitions(womOrigin, accountSlug, t) {
    var _a;
    const base = [
        {
            id: "iframe.dashboard",
            title: t("navigation:links.dashboard"),
            link: "/WOM/dashboard",
            icon: "home",
            urlMatches: [/^\/$/i, /^\/WOM\/dashboard$/i],
            isActive: true,
        },
        {
            id: "iframe.opsDashboard",
            title: t("navigation:links.dashboard_opsDashboard"),
            icon: "calendar check",
            urlMatches: [/^\/WOM\/dashboard\/.+/i],
            isActive: p => p.includes("MASONHUB_ADMIN") || p.includes("SUPER_USER"),
            subitems: [
                {
                    id: "iframe.dashboard.ops",
                    title: t("navigation:links.dashboard_outboundFulfillments"),
                    link: "/WOM/dashboard/ops",
                    urlMatches: [/^\/WOM\/dashboard\/ops$/i],
                    isActive: p => p.includes("MASONHUB_ADMIN") || p.includes("SUPER_USER"),
                },
                {
                    id: "iframe.dashboard.asnReceiving",
                    title: t("navigation:links.dashboard_asnReceiving"),
                    link: "/WOM/dashboard/asn_receiving",
                    urlMatches: [/^\/WOM\/dashboard\/asn_receiving$/i],
                    isActive: p => p.includes("MASONHUB_ADMIN") || p.includes("SUPER_USER"),
                },
                {
                    id: "iframe.dashboard.rmaReceiving",
                    title: t("navigation:links.dashboard_rmaReceiving"),
                    link: "/WOM/dashboard/rma_receiving",
                    urlMatches: [/^\/WOM\/dashboard\/rma_receiving$/i],
                    isActive: p => p.includes("MASONHUB_ADMIN") || p.includes("SUPER_USER"),
                },
                {
                    id: "iframe.dashboard.workOrders",
                    title: t("navigation:links.dashboard_workOrders"),
                    link: "/WOM/dashboard/work_orders",
                    urlMatches: [/^\/WOM\/dashboard\/work_orders$/i],
                    isActive: p => p.includes("MASONHUB_ADMIN") || p.includes("SUPER_USER"),
                },
            ]
        },
        {
            id: "iframe.opsReports",
            title: t("navigation:links.opsReports"),
            icon: "chart line",
            link: "/WOM/ops-reports",
            urlMatches: [/^\/(WOM\/ops-reports)/i],
            isActive: p => p.includes("MASONHUB_ADMIN") || p.includes("SUPER_USER"),
        },
        {
            id: "iframe.catalog",
            title: t("navigation:links.catalog"),
            icon: "barcode",
            urlMatches: [/^\/WOM\/skus\/[0-9a-f-]+/i, /^\/WOM\/thresholds/i, /^\/WOM\/oversell_policies/i, /^\/WOM\/snapshots/i],
            isActive: true,
            subitems: [
                {
                    id: "iframe.catalog.allSkus",
                    title: t("navigation:links.catalog_allSkus"),
                    link: "/WOM/skus",
                    urlMatches: [
                        /^\/WOM\/skus$/i,
                        path => path.indexOf("/WOM/skus") === 0 &&
                            path.indexOf("inventory_level=backordered") < 0,
                    ],
                    isActive: true,
                },
                {
                    id: "iframe.catalog.salesVelocity",
                    title: t("navigation:links.catalog_sales_velocity"),
                    link: "/WOM/skus/sales_velocity",
                    urlMatches: [/^\/WOM\/skus\/sales_velocity$/i],
                    isActive: true,
                },
                {
                    id: "iframe.catalog.thresholds",
                    title: t("navigation:links.thresholds"),
                    link: "/WOM/thresholds",
                    urlMatches: [/^\/WOM\/thresholds$/i],
                    isActive: p => p.includes("SUPER_USER"),
                },
                {
                    id: "iframe.catalog.backorderedSkus",
                    title: t("navigation:links.catalog_backorderedSkus"),
                    link: "/WOM/skus?inventory_levels=isBackorder",
                    urlMatches: [/^\/WOM\/skus\?.*?&?inventory_level=backordered/i],
                    isActive: true,
                },
                {
                    id: "iframe.catalog.createSku",
                    title: t("navigation:links.catalog_createSku"),
                    link: "/WOM/skus/new",
                    urlMatches: [/^\/WOM\/skus\/new$/i],
                    isActive: p => p.includes("SKU_CREATE"),
                },
                {
                    id: "iframe.asns.createSku",
                    title: t("navigation:links.catalog_uploadSku"),
                    link: "/WOM/upload/skus",
                    urlMatches: [/^\/WOM\/upload\/skus$/i],
                    isActive: p => p.includes("MASONHUB_ADMIN") || p.includes("SUPER_USER"),
                },
                {
                    id: "iframe.catalog.oversellPolicies",
                    title: t("navigation:links.catalog_oversellPolicies"),
                    link: "/WOM/oversell_policies",
                    urlMatches: [/^\/WOM\/oversell_policies/i],
                    isActive: p => p.includes("MASONHUB_ADMIN") || p.includes("SUPER_USER"),
                },
                {
                    id: "iframe.catalog.inventorySnapshots",
                    title: t("navigation:links.catalog_inventorySnapshots"),
                    link: "/WOM/snapshots",
                    urlMatches: [/^\/WOM\/snapshots/i],
                    isActive: true,
                },
            ],
        },
        {
            id: "iframe.asns",
            title: t("navigation:links.inboundShipments"),
            icon: "list alternate outline",
            urlMatches: [/^\/WOM\/inbound_shipments\/[0-9a-f-]+/i, /^\/WOM\/upload\/inbound_shipments$/i],
            isActive: true,
            subitems: [
                {
                    id: "iframe.asns.inboundShipments",
                    title: t("navigation:links.inboundShipments_allInboundShipments"),
                    link: "/WOM/inbound_shipments",
                    urlMatches: [/^\/WOM\/inbound_shipments/i],
                    isActive: true,
                },
                {
                    id: "iframe.asns.uploadAsn",
                    title: t("navigation:links.inboundShipments_uploadAsn"),
                    link: "/WOM/upload/inbound_shipments",
                    urlMatches: [/^\/WOM\/upload\/inbound_shipments$/i],
                    isActive: true,
                },
            ],
        },
        {
            id: "iframe.orders",
            title: t("navigation:links.orders"),
            icon: "box",
            urlMatches: [/^\/WOM\/orders\/[0-9a-f-]+/i, /^\/WOM\/print$/i, /^\/WOM\/upload\/orders$/i],
            isActive: true,
            subitems: [
                {
                    id: "iframe.orders.printPackslip",
                    title: t("navigation:links.orders_printPackSlip"),
                    link: "/WOM/print",
                    urlMatches: [/^\/WOM\/print/i],
                    isActive: p => p.includes("MASONHUB_ADMIN") || p.includes("SUPER_USER"),
                },
                {
                    id: "iframe.orders.ordersAndShipments",
                    title: t("navigation:links.orders_allOrdersAndShipments"),
                    link: "/WOM/orders",
                    urlMatches: [/^\/WOM\/orders/i],
                    isActive: true,
                },
                {
                    id: "iframe.orders.backorders",
                    title: t("navigation:links.orders_allBackorders"),
                    link: "/WOM/backorders",
                    urlMatches: [/^\/WOM\/backorders/i],
                    isActive: true,
                },
                {
                    id: "iframe.orders.createOrder",
                    title: t("navigation:links.orders_createOrder"),
                    link: "/WOM/orders/new",
                    urlMatches: [/^\/WOM\/orders\/new$/i],
                    isActive: p => p.includes("CLIENT_ADMIN") || p.includes("MASONHUB_ADMIN") || p.includes("SUPER_USER"),
                },
                {
                    id: "iframe.orders.uploadOrders",
                    title: t("navigation:links.orders_uploadOrders"),
                    link: "/WOM/upload/orders",
                    urlMatches: [/^\/WOM\/upload\/orders$/i],
                    isActive: p => p.includes("CLIENT_ADMIN") || p.includes("MASONHUB_ADMIN") || p.includes("SUPER_USER"),
                },
            ],
        },
        {
            id: "iframe.rmas",
            title: t("navigation:links.returns"),
            icon: "exchange",
            urlMatches: [/^\/WOM\/rmas\/[0-9a-f-]+/i, /^\/WOM\/upload\/rmas$/i],
            isActive: true,
            subitems: [
                {
                    id: "iframe.rmas.rmas",
                    title: t("navigation:links.returns_allReturns"),
                    link: "/WOM/rmas",
                    urlMatches: [/^\/WOM\/rmas/i],
                    isActive: true,
                },
                {
                    id: "iframe.rmas.createRma",
                    title: t("navigation:links.returns_createRma"),
                    link: "/WOM/rmas/new",
                    urlMatches: [/^\/WOM\/rma\/new$/i],
                    isActive: true,
                },
                {
                    id: "iframe.rmas.uploadRmas",
                    title: t("navigation:links.returns_uploadRmas"),
                    link: "/WOM/upload/rmas",
                    urlMatches: [/^\/WOM\/upload\/rmas$/i],
                    isActive: p => p.includes("MASONHUB_ADMIN") || p.includes("SUPER_USER"),
                },
            ],
        },
        {
            id: "iframe.reports",
            title: t("navigation:links.reports"),
            icon: "chart bar",
            urlMatches: [/^\/WOM\/reports\/[0-9a-f-]+/i],
            isActive: true,
            subitems: [
                {
                    id: "iframe.dashboard.links.inventoryRollForward",
                    title: t("navigation:links.inventoryRollForward"),
                    link: "/WOM/reports/inventory-roll-forward",
                    urlMatches: [/^\/(WOM\/reports\/inventory-roll-forward)/i],
                    isActive: true,
                },
                {
                    id: "iframe.dashboard.links.fillRate",
                    title: t("navigation:links.fillRate"),
                    link: "/WOM/reports/fill-rate",
                    urlMatches: [/^\/(WOM\/reports\/fill-rate)/i],
                    isActive: true,
                },
                {
                    id: "iframe.dashboard.links.ecommSla",
                    title: t("navigation:links.ecommSla"),
                    link: "/WOM/reports/ecomm_sla",
                    urlMatches: [/^\/(WOM\/reports\/ecomm_sla)/i],
                    isActive: true,
                },
                {
                    id: "iframe.dashboard.links.inboundShipmentSla",
                    title: t("navigation:links.inboundShipmentSla"),
                    link: "/WOM/reports/inbound-shipments-sla/",
                    urlMatches: [/^\/(WOM\/reports\/inbound-shipments-sla)/i],
                    isActive: true,
                },
                {
                    id: "iframe.dashboard.links.returnsSla",
                    title: t("navigation:links.returnsSla"),
                    link: "/WOM/reports/returns-sla",
                    urlMatches: [/^\/(WOM\/reports\/returns-sla)/i],
                    isActive: true,
                },
                {
                    id: "iframe.dashboard.links.lotExpiry",
                    title: t("navigation:links.lotExpiry"),
                    link: "/WOM/reports/lot-expiry",
                    urlMatches: [/^\/(WOM\/reports\/lot-expiry)/i],
                    isActive: p => p.includes("MASONHUB_ADMIN") || p.includes("SUPER_USER"),
                },
                {
                    id: "iframe.dashboard.links.forecast",
                    title: t("navigation:links.forecast"),
                    link: "/WOM/reports/forecast",
                    urlMatches: [/^\/(WOM\/reports\/forecast)/i],
                    isActive: p => p.includes("MASONHUB_ADMIN") || p.includes("SUPER_USER"),
                },
                {
                    id: "iframe.dashboard.links.ecommAgingOrders",
                    title: t("navigation:links.ecommAgingOrders"),
                    link: "/WOM/reports/ecomm-aging-orders",
                    urlMatches: [/^\/(WOM\/reports\/ecomm_aging_orders)/i],
                    isActive: true,
                },
                {
                    id: "iframe.dashboard.links.ecommShortedOrders",
                    title: t("navigation:links.ecommShortedOrders"),
                    link: "/WOM/reports/ecomm-shorted-orders",
                    urlMatches: [/^\/(WOM\/reports\/ecomm_shorted_orders)/i],
                    isActive: true,
                },
                {
                    id: "iframe.dashboard.links.inventoryAdjustments",
                    title: t("navigation:links.inventoryAdjustments"),
                    link: "/WOM/reports/inventory-adjustments",
                    urlMatches: [/^\/(WOM\/reports\/inventory-adjustments)/i],
                    isActive: true,
                },
            ],
        },
        {
            id: "iframe.billing",
            title: t("navigation:links.billing"),
            icon: "dollar sign",
            urlMatches: [/^\/WOM\/billing/i],
            isActive: p => p.includes("SUPER_USER"),
            subitems: [
                {
                    id: "iframe.billing.accountBilling",
                    title: t("navigation:links.accountBilling"),
                    link: "/WOM/billing",
                    urlMatches: [/^\/WOM\/billing/i],
                    isActive: true,
                },
                {
                    id: "iframe.billing.inboundInvoice",
                    title: t("navigation:links.inboundInvoice"),
                    link: "/WOM/billing/inbound_invoice",
                    urlMatches: [/^\/WOM\/billing\/inbound_invoice/i],
                    isActive: true,
                },
                {
                    id: "iframe.billing.returnInvoice",
                    title: t("navigation:links.returnInvoice"),
                    link: "/WOM/billing/return_invoice",
                    urlMatches: [/^\/WOM\/billing\/return_invoice/i],
                    isActive: true,
                },
                {
                    id: "iframe.billing.outboundInvoice",
                    title: t("navigation:links.outboundInvoice"),
                    link: "/WOM/billing/outbound_invoice",
                    urlMatches: [/^\/WOM\/billing\/outbound_invoice/i],
                    isActive: true,
                },
            ],
        },
        {
            id: "iframe.accountManagement",
            title: t("navigation:links.accountManagement"),
            icon: "cog",
            urlMatches: [/^\/WOM\/accounts/i, /^\/WOM\/account\/[0-9a-f-]+/i, /^\/WOM\/users\/[0-9a-f-]+/i, /^\/WOM\/shipmethods\/[0-9a-f-]+/i, /^\/WOM\/invitations\/[0-9a-f-]+/i],
            isActive: p => p.includes("CLIENT_ADMIN") || p.includes("MASONHUB_ADMIN") || p.includes("SUPER_USER"),
            subitems: [
                {
                    id: "iframe.accountManagement.accountProfile",
                    title: t("navigation:links.accountManagement_accountProfile"),
                    link: `/WOM/account/${encodeURIComponent(accountSlug)}`,
                    urlMatches: [/^\/WOM\/accounts/i],
                    isActive: p => p.includes("CLIENT_ADMIN")
                },
                {
                    id: "iframe.accountManagement.account",
                    title: t("navigation:links.accountManagement_accounts"),
                    link: "/WOM/accounts",
                    urlMatches: [/^\/WOM\/accounts/i],
                    isActive: p => p.includes("MASONHUB_ADMIN") || p.includes("SUPER_USER"),
                },
                {
                    id: "iframe.accountManagement.newAccount",
                    title: t("navigation:links.accountManagement_newAccount"),
                    link: "/WOM/accounts/new",
                    urlMatches: [/^\/WOM\/accounts\/new$/i],
                    isActive: p => p.includes("SUPER_USER"),
                },
                {
                    id: "iframe.accountManagement.shipMethods",
                    title: t("navigation:links.accountManagement_shipMethods"),
                    link: "/WOM/shipmethods",
                    urlMatches: [/^\/WOM\/shipmethods/i],
                    isActive: true,
                },
                {
                    id: "iframe.accountManagement.users",
                    title: t("navigation:links.accountManagement_users"),
                    link: "/WOM/users",
                    urlMatches: [/^\/WOM\/users/i],
                    isActive: true,
                },
                {
                    id: "iframe.accountManagement.invitations",
                    title: t("navigation:links.accountManagement_invitations"),
                    link: "/WOM/invitations",
                    urlMatches: [/^\/WOM\/invitations/i],
                    isActive: p => p.includes("MASONHUB_ADMIN") || p.includes("SUPER_USER"),
                },
            ],
        },
        {
            id: "iframe.invitations",
            title: t("navigation:links.invitations"),
            urlMatches: [],
            isActive: p => !p.includes("MASONHUB_ADMIN") && p.includes("CLIENT_ADMIN"),
            subitems: [
                {
                    id: "iframe.invitations.list",
                    title: t("navigation:links.invitations_invitationList"),
                    link: "/WOM/invitations",
                    urlMatches: [/^\/WOM\/invitations$/i],
                    isActive: true,
                },
                {
                    id: "iframe.invitations.new",
                    title: t("navigation:links.invitations_newInvitation"),
                    link: "/WOM/invitations/new",
                    urlMatches: [/^\/WOM\/invitations\/new/i],
                    isActive: true,
                },
            ],
        },
        {
            id: "iframe.warehouse",
            title: t("navigation:links.warehouse"),
            icon: "warehouse",
            urlMatches: [/^\/WOM\/warehouse/i],
            isActive: p => p.includes("MASONHUB_ADMIN") || p.includes("SUPER_USER"),
            subitems: [
                {
                    id: "iframe.adminAccountManagement.settings",
                    title: t("navigation:links.warehouseManagement_settings"),
                    link: "/WOM/warehouse/settings",
                    urlMatches: [/^\/WOM\/warehouse\/settings/i],
                    isActive: true,
                },
                {
                    id: "iframe.adminWarehouseManagement.daysOff",
                    title: t("navigation:links.warehouseManagement_daysOff"),
                    link: "/WOM/warehouse/days_off",
                    urlMatches: [/^\/WOM\/warehouse\/days_off/i],
                    isActive: true,
                },
                {
                    id: "iframe.adminWarehouseManagement.printStations",
                    title: t("navigation:links.adminWarehouseManagement_printStations"),
                    link: "/WOM/warehouse/print_stations",
                    urlMatches: [/^\/WOM\/warehouse\/print_stations/i],
                    isActive: p => p.includes("NAV_PRINT_STATION"),
                },
            ],
        },
        {
            id: "iframe.invitations",
            title: t("navigation:links.accountManagement_invitations"),
            link: "/WOM/invitations/",
            urlMatches: [/^\/WOM\/invitations/i],
            isActive: p => p.includes("CLIENT_ADMIN") || p.includes("USER"),
        },
        {
            id: "iframe.callbacks",
            title: t("navigation:links.callbacks"),
            icon: "cogs",
            link: "/WOM/callbacks",
            urlMatches: [/^\/WOM\/callbacks$/i],
            isActive: p => p.includes("CLIENT_ADMIN") || p.includes("MASONHUB_ADMIN") || p.includes("SUPER_USER") && p.includes("NAV_CALLBACK"),
        },
        {
            id: "uiV1",
            title: t("navigation:links.uiV1"),
            icon: "reply",
            link: womOrigin,
            urlMatches: [],
            isActive: true,
        },
        {
            id: "iframe.logout",
            title: t("navigation:links.logout"),
            icon: "sign out alternate",
            link: `${womOrigin}/logout`,
            urlMatches: [],
            isActive: true,
        },
    ];
    for (const mainItem of base) {
        if ((_a = mainItem.subitems) === null || _a === void 0 ? void 0 : _a.length) {
            mainItem.urlMatches = mainItem.subitems.reduce((acc, i) => acc.concat(i.urlMatches), mainItem.urlMatches);
        }
    }
    return base;
}
exports.getNavigationDefinitions = getNavigationDefinitions;
